import { buildQueryString, fetch, handleResponse } from '../utils/apiUtils';

class UserService {

  static getCurrentUserProfile() {
    return fetch(`${process.env.REACT_APP_API_URL}/api/users/me`)
      .then(handleResponse)
      .then(resp => resp.data);
  }

  static get(params) {

    let queryString = buildQueryString(params);

    return fetch(`${process.env.REACT_APP_API_URL}/api/users?${queryString}`)
      .then(handleResponse)
      .then(resp => {
        return {
          totalCount: resp.meta.totalResults,
          items: resp.data
        }
      });
  }

  static getById(id) {
    return fetch(`${process.env.REACT_APP_API_URL}/api/users/${id}`)
      .then(handleResponse)
      .then(resp => resp.data);
  }

  static create(userModel) {

    const request = {
      method: 'POST',
      headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json'
      },
      body: JSON.stringify({ data: userModel })
    };

    return fetch(`${process.env.REACT_APP_API_URL}/api/users/`, request)
      .then(handleResponse);
  }

  static save(userModel) {

    const request = {
      method: 'PUT',
      headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json'
      },
      body: JSON.stringify({ data: userModel })
    };

    return fetch(`${process.env.REACT_APP_API_URL}/api/users/${userModel.id}`, request)
      .then(handleResponse);
  }
}

export default UserService;



// WEBPACK FOOTER //
// ./src/services/UserService.js